exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ui.table[data-v-076443b0]{word-break:break-all}.ui.table.mt[data-v-076443b0]{margin-top:8px}.ui.table td[data-v-076443b0]:first-child{width:70px}", ""]);

// exports
